import { Injectable } from '@angular/core';

import { DateTimeFormatterFormatType, LocaleService } from './locale.service';

@Injectable()
export class EnLocaleService extends LocaleService {
    private readonly locale = 'en';

    constructor() {
        super();
    }

    format(date: Date, format: DateTimeFormatterFormatType, extended: boolean = false): string {
        switch (format) {
            case DateTimeFormatterFormatType.Date:
                return date.toLocaleDateString(this.locale);
            case DateTimeFormatterFormatType.Time:
                return extended 
                    ? date.toLocaleTimeString(this.locale, { hour: '2-digit', minute: '2-digit', second: '2-digit' }) 
                    : date.toLocaleTimeString(this.locale, { hour: '2-digit', minute: '2-digit' });
        }
    }

    getCurrentLocaleToken(): string {
        return this.locale;
    }

    getCurrentWeekDaySeparator(): string {
        return 'to';
    }

    getDateExtended(date: Date, showWeekDay: boolean = false): string {
        const fullDate = date.toLocaleDateString(this.locale, { day: '2-digit', month: 'long', year: 'numeric' });

        let weekday = date.toLocaleDateString(this.locale, { weekday : 'long'});
        weekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);

        return showWeekDay ? `${weekday}, ${fullDate}` : `${fullDate}`; 
    }

    getDateTimeExtended(date: Date, showWeekDay: boolean = false): string {
        const fullDate = date.toLocaleDateString(this.locale, { day: '2-digit', month: 'long' });

        let weekday = date.toLocaleDateString(this.locale, { weekday : 'long'});
        weekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);

        const time = date.toLocaleTimeString(this.locale, { hour: '2-digit', minute: '2-digit' });

        return showWeekDay ? `${weekday}, ${fullDate}, ${time}` : `${fullDate}, ${time}`; 
    }

    getDateShort(date: Date): string {
        const day = date.toLocaleDateString(this.locale, { day: '2-digit' });
        const month = date.toLocaleDateString(this.locale, { month: 'short' });
        return `${day} ${month}`;
    }

    getDateMonthNameFormat(): Intl.DateTimeFormat {
        return new Intl.DateTimeFormat('en-EN', { month: 'short' });
    }

    getElapsedTimeSlugs(): string[] {
        return ['now', 'min', 'h', 'days'];
    }

    getFiscalNumberRegex(): string {
        // https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s21.html
        return '(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})';
    }

    getPhoneNumberRegex(): string {
        return '^[0-9]{9,}';
    }
    
    getPhraseConnectorsRegex(): string {
        return ['^(\\s*)(the?|of?)(\\s+)', '(\\s+)(the?|of?)(\\s+)', '(\\s+)(the?|of?)(\\s*)$'].join('|');
    }
   
    getRangeDateSeparator(): string {
        return 'to';
    }

    validateFiscalNumber(fiscalNumber: string): boolean {
        return true;
    }
}
